<template>
  <v-dialog v-model="dialogLocal" max-width="450px" @click:outside="dialogLocal = false">
    <v-card>
      <v-card-title class="headline">Editar {{ items.nome }}</v-card-title>
      <v-divider />
      <v-card-text>
        <v-text-field v-model="nome" label="Nome" outlined :disabled="items.usuario_id != $store.getters.getUserIdHexa" />
        <v-textarea
          v-model="instrucao"
          no-resize
          outlined
          hide-details
          label="Instrução"
          placeholder="Informe aqui uma instrução para a importação do arquivo... "
        />
        <v-alert dense outlined type="info" color="blue" class="mt-4 pa-0">
          Atenção: estas instruções serão exibidas na tela de mapeamento da importação de dados
        </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="dialogLocal = false">Fechar</v-btn>
        <v-btn color="green darken-1" :loading="loading" @click="salvar()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import Mapeamento from '@/services/MapeamentoService.js';

  export default {
    props: {
      items: {
        type: Object,
        default: () => {}
      },
      showDialog: {
        type: Boolean,
        default: false
      }
    },

    emits: ['update:showDialog', 'reloadItemsTabela'],

    data: () => ({
      nome: '',
      instrucao: '',
      loading: false
    }),

    computed: {
      dialogLocal: {
        get() {
          return this.showDialog;
        },
        set(newValue) {
          this.$emit('update:showDialog', newValue);
        }
      }
    },

    methods: {
      popularCampo() {
        this.instrucao = this.items.instrucao;
        this.nome = this.items.nome;
      },

      salvar() {
        this.loading = true;

        let data = {
          id: this.items.id,
          nome: this.nome,
          instrucao: this.instrucao
        };
        Mapeamento.editMapeamento(data)
          .then(() => {
            this.dialogLocal = false;
            this.$emit('reloadItemsTabela');
            this.$toast.success('Mapeamento editado com com sucesso.', '', { position: 'topRight' });
          })
          .catch((err) => {
            this.popularCampo();
            this.$toast.error(err.data.erro, '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    },

    watch: {
      showDialog(newValue) {
        if (newValue) {
          this.popularCampo();
        }
      }
    }
  };
</script>